import { filterNavigation } from './navigation';
import { Environment } from './environment.types';
import productionEnvironment from './environment.production';

const environment: Partial<Environment> = {
  ...productionEnvironment,
  apiBaseUrl: 'https://digiteyez-qms-api.sierralabs.com/api/',
  navigation: filterNavigation(
    'Dashboard',
    'Training Admin',
    'Documents',
    'Products',
    'Risk Management',
    'Hazards',
    'CAPA',
    'Supplier Management',
    'SCAR',
    'Teams',
    'Employees',
    'Workflow',
    'Task Types'
  ),
  productConfig: {
    userNeed: { disableRelations: ['validations', 'verifications'] },
    designInput: {
      disableRelations: ['validations', 'verifications', 'designSpecs']
    },
    designOutput: {
      disableRelations: ['validations', 'verifications', 'designSpecs']
    }
  },
  riskConfig: {
    hideCategory: true
  }
};

export default environment;
